import React, { useEffect, useState } from "react";
import styles from "./CollaboratorsMap.module.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { getCollaboratorsMap } from "../../api/Public/collaborators";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const CollaboratorsMap = () => {
    const [traders, setTraders] = useState(null);
    useEffect(() => {
        async function fetchTraders() {
            const traders = await getCollaboratorsMap();
            setTraders(traders.data);
        }
        fetchTraders();
    }, []);

    return (
        <div className={styles.layout}>
            <h1 className={styles.title}>Nos partenaires près de chez vous</h1>
            <div className={styles.map}>
                <MapContainer
                    center={[49.894293, 2.295736]}
                    zoom={13}
                    style={{ height: "100%", width: "100%" }}
                >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />

                {traders && <>
                    {traders.map((trader, index) => (
                        <Marker key={index} position={[parseFloat(trader.latitude), parseFloat(trader.longitude)]}>
                            <Popup>{trader.company}</Popup>
                        </Marker>
                    ))}
                </>}

                </MapContainer>
            </div>
        </div>
    );
};

export default CollaboratorsMap;
